import axios from 'src/api/Api';
import {
    DASHBOARD_EXPORT_SUCCESS,
    DASHBOARD_EXPORT_FAILURE,
} from '../actions';
import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

const buildUrl = (baseSiteId, params = {}) => {
    const queryParams = new URLSearchParams(
        Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
    );

    const qs = queryParams.toString();

    return qs
        ? `/occ/v2/${baseSiteId}/dashboard/export?${qs}`
        : `/occ/v2/${baseSiteId}/dashboard/export`;
};

export default function* dashboardExport(action) {
    const baseSiteId = localStorage.getItem('baseSiteId');    
    const url = buildUrl(baseSiteId, { ...action?.payload });
    console.log('prateeks',url);    
    try {
        const result = yield axios.get(url, { responseType: 'blob' }).then((response) => response.data);
        yield put({ type: DASHBOARD_EXPORT_SUCCESS, payload: result });
    } catch (error) {
        logUiErrorToBackend(error, { apiEndPoint: url });
        yield put({ type: DASHBOARD_EXPORT_FAILURE, payload: { error: errorHandler('503') } });
    }
}
 
 